import React from 'react';

const LoadingScreen = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-green-100 via-white to-green-200 animate-fade-in">
            <div className="flex flex-col items-center space-y-6">
                <div className="relative">
                    <div className="w-20 h-20 border-4 border-green-400 border-dashed rounded-full animate-spin"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-10 h-10 bg-green-400 rounded-full animate-pulse"></div>
                    </div>
                </div>
                <p className="text-xl font-medium text-gray-700 text-center tracking-wide animate-bounce">
                    Please wait while we prepare everything...
                </p>
                <div className="w-64 h-2 bg-green-100 rounded-full overflow-hidden">
                    <div className="h-full bg-green-500 animate-loading-bar"></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
